import { all, put, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'

import config from '../../config'

import { BLOCK_DATA_LOADED } from '../../scenes/Gnosus/components/Workspace/components/HocBlock/constants'
import { blockSaveCustomData } from '../../scenes/Gnosus/components/Workspace/components/HocBlock/actions'

import { setYears } from '../FinanceTable/actions'

import { FANAL_TOGGLE_GRAPH_TABLE, FANAL_CHANGE_SELECTED_YEAR } from './constants'

function* fanalBlockLoaded(action) {
    const blockKey = _.get(action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.fanal.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const data = _.get(action, 'data.data', null)
    const selectedYear = _.get(data, 'analysisData[0].year', null) // Also newCompareYear
    const newSampleYear = _.get(data, 'analysisData[1].year', null)

    const sectorSelectedYear = _.get(data, 'sector[0].year', null)
    const sectorNewSampleYear = _.get(data, 'sector[1].year', null)

    yield put(setYears(id, 'analysis', selectedYear, newSampleYear))
    yield put(setYears(id, 'analysis-sector', sectorSelectedYear, sectorNewSampleYear))

    yield put(
        blockSaveCustomData(module, id, blockKey, {
            radarGraph: {
                showDataTable: true,
                selectedYear,
            },
        })
    )

    return null
}

function* fanalChangeCustomData(action) {
    const blockKey = _.get(action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.fanal.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const customData = _.get(action, 'data.customData', null)

    yield put(blockSaveCustomData(module, id, blockKey, customData))

    return null
}

// Saga is yielded in "src/scenes/saga"
export default function* fanalSaga() {
    yield all([
        takeEvery(BLOCK_DATA_LOADED, fanalBlockLoaded),
        takeEvery(FANAL_TOGGLE_GRAPH_TABLE, fanalChangeCustomData),
        takeEvery(FANAL_CHANGE_SELECTED_YEAR, fanalChangeCustomData),
    ])
}
